module.exports = __webpack_public_path__ + "img/madalena-beautique-hotels.a56867de.jpg";